import { ChangeDetectionStrategy, Component, inject, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { TherapistService } from '../../../../../services/api/TherapistService';
import { TherapistEventService } from '../../../../../services/api/TherapistEventService';
import { EventService } from '../../../../../services/api/EventService';
import { TherapistModel } from '../../../../../models/api/TherapistModel';
import { TherapistEventDetailsModel } from '../../../../../models/api/TherapistEventDetails';
import { forkJoin } from 'rxjs';
import { A11yModule } from "@angular/cdk/a11y";
import { EventModel } from '../../../../../models/api/EventModel';
import { MatIconModule } from '@angular/material/icon';
import { TherapistEventModel } from '../../../../../models/api/TherapistEventModel';
import { MatButtonModule } from '@angular/material/button';
import { Dialog } from '@angular/cdk/dialog';
import { EventDeleteDialog } from '../../../all-events/all-events.component';
import { HelpersModule } from '../../../../../helpers/helpers';

@Component({
  selector: 'app-assign-therapist-to-event',
  standalone: true,
  imports: [MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose, MatButtonModule, A11yModule, MatIconModule,],
  templateUrl: './assign-therapist-to-event.component.html',
  styleUrl: './assign-therapist-to-event.component.scss'
})
export class AssignTherapistToEventComponent implements OnInit {

  public allTherapists: TherapistModel[] = [];
  public therapistsAtEvent: TherapistEventDetailsModel[] = [];
  public therapistsNotAtEvent: TherapistModel[] = [];
  public eventTherapistIds = new Set<number>();
  public eventData: EventModel = new EventModel;
  public eventID: number = 0;
  public isReloading: boolean = false;

  readonly dialog = inject(MatDialog);


  constructor(
    private therapistService: TherapistService,
    private therapistEventService: TherapistEventService,
    private eventService: EventService,
    @Inject(MAT_DIALOG_DATA) public data?: { eventID: number }
  ) {
    if (data?.eventID){
          this.eventID = data?.eventID!;
    }
  }

  ngOnInit(): void {
    this.getTherapists();
  }


  getTherapists() {


    forkJoin({
      therapistsAtEvent: this.therapistEventService.getByEvent(this.eventID),
      allTherapistsResponse: this.therapistService.findTherapist(),
      eventData: this.eventService.getEvent(this.eventID),
    }).subscribe({
      next: ({ therapistsAtEvent, allTherapistsResponse, eventData }) => {

        this.eventData = eventData;

        this.therapistsAtEvent = Array.from(
          new Map(therapistsAtEvent.map(t => [t.therapistId, t])).values()
        )

        this.allTherapists = allTherapistsResponse.data as TherapistModel[];

        this.eventTherapistIds = new Set(
          this.therapistsAtEvent
            .map(t => t.therapistId)
            .filter((id): id is number => id !== undefined)
        );

        if (!this.isReloading) {
          this.therapistsNotAtEvent = this.allTherapists.filter(
            t => !this.eventTherapistIds.has(t.therapistID)
          );
        }

        this.isReloading = false;
      },
      error: (err) => {
        console.error(err);
      }
    });
  }

  removeTherapistFromEvent(therapistID: number) {
    this.therapistEventService.deleteByTherapistAndEvent(therapistID, this.eventID).subscribe({
      next: (data) => {
        this.isReloading = true;
        this.getTherapists();
      },
      error: (err) => {
      }
    })
  }

  toggleTherapistAtEvent(therapistID: number) {
    if (this.therapistsAtEvent.find(t => (t.therapistId === therapistID))) {
      this.removeTherapistFromEvent(therapistID);
    } else {
      this.addTherapistToEvent(therapistID);
    }
  }

  addTherapistToEvent(therapistID: number) {


    this.therapistEventService.createTherapistEventRange(this.eventID, therapistID, true).subscribe({
      next: (data) => {
        this.isReloading = true;
        this.getTherapists();
      },
      error: (err) => {
      }
    })
  }

  getThumbURL(url: string | undefined | null ): string | undefined | null {
    if (url == undefined || url == null)
      return url;

    return HelpersModule.cloudinaryURLForceWidth(url, 60);
  }

}
